import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "children", "classes", "color", "disabled", "icon", "iconPosition", "loading", "namespace", "size", "onClick", "view", "weight"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { ButtonBase } from "../internal/ButtonBase";
import { TextBase } from "../internal/TextBase";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import Loader from '../Loader';
import styles from './Link.css';
var cx = classNames.bind(styles);
export var Link = /*#__PURE__*/forwardRef(function Link(_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'a' : _ref$as,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      color = _ref.color,
      disabled = _ref.disabled,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      loading = _ref.loading,
      namespace = _ref.namespace,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      onClick = _ref.onClick,
      _ref$view = _ref.view,
      view = _ref$view === void 0 ? 'b2c' : _ref$view,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'semibold' : _ref$weight,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'link'),
      getTestId = _getMethodsForTestId.getTestId;

  var FinalComponent = Component === 'button' ? ButtonBase : Component;

  var Icon = function Icon() {
    return icon || loading ? /*#__PURE__*/React.createElement("span", {
      className: cx('icon', "position_".concat(iconPosition), classes.icon)
    }, /*#__PURE__*/React.createElement("span", {
      className: cx('icon_wrap', classes.iconWrap)
    }, loading ? /*#__PURE__*/React.createElement(Loader, {
      size: "x-small",
      color: "inherit"
    }) : icon)) : null;
  };

  return /*#__PURE__*/React.createElement(TextBase, _extends({}, rest, {
    onClick: onClick,
    ref: ref,
    size: size,
    as: FinalComponent,
    weight: weight,
    classes: {
      root: cx('root', _defineProperty({
        loading: loading,
        disabled: disabled
      }, "view_".concat(view), !color), classes.root)
    },
    color: color
  }, getTestId()), /*#__PURE__*/React.createElement("span", {
    className: cx('inner', classes.inner)
  }, iconPosition === 'left' && /*#__PURE__*/React.createElement(Icon, null), children && /*#__PURE__*/React.createElement("span", {
    className: cx('text', classes.text)
  }, children), iconPosition === 'right' && /*#__PURE__*/React.createElement(Icon, null)));
});
export default Link;